import { Article } from './enums';
import { ContentType } from '@pages/Articles/Articles.types.ts';

export const compoundKeysArticle = {
  id: 'compound-keys-react-001',
  slug: 'compound-keys-react-modern-switch-case',
  title: 'Композитные ключи в React+TS или когда switch-case не всегда удобно',
  date: '2026-04-02',
  author: Article.Author,
  content: [
    {
      type: ContentType.Paragraph,
      content:
        'Часто в проектах вижу ад, 200 строк switch-case для роутинга, статусов или типов виджетов или комбинации вложенных свитчей сверху тип снизу тэг. А потом что-то нужно добавить - и привет, правка на час. Покажу композитные ключи это современный подход, который сократил мои свитчи с 300 строк до 10',
    },
    {
      type: ContentType.Code,
      content: `// ❌ Switch hell
switch (type) {
  case 'user.admin': 
    return <AdminPanel />;
    
  case 'user.guest': 
    return <GuestPanel />;
    
  case 'post.draft': 
    return <DraftPost />;
    
  case 'post.published': 
    return <PublishedPost />;
        
// +50 cases решаем merge conflict целый день
}`,
    },
    {
      type: ContentType.Paragraph,
      content: `Был один проект где было много кейсов, решил проработать. Где был большой свитч, интересно что теперь? Один объект с композитными ключами. Рефакторинг x10 быстрее, как мы помним написать код дешево, а вот дебагинг штука дорогая, даже с приходом ИИ`,
    },
    {
      type: ContentType.Heading,
      content: 'Что такое композитные ключи?',
    },
    {
      type: ContentType.Paragraph,
      content:
        'Это эликсир "Кошка" для глаз Геральта ночью, а если серьезно, то ключ = scope + entity + state, также можно сочетать вместе с разделитилем. Вместо string - tuple или составной объект:',
    },
    {
      type: ContentType.Code,
      content: `// ✅ Compound keys
type Scope = 'user' | 'post' | 'comment';
type EntityState = 'loading' | 'success' | 'error' | 'empty';

// некоторые строки пришлось экранировать :3
type CompoundKey = \`${'Scope'}.${'string'}\` | readonly [Scope, string, EntityState];

const COMPONENTS: Record<CompoundKey, React.ComponentType> = {
  // String variant (быстрее)
  'user.admin.success': AdminPanel,
  'user.guest.loading': GuestSkeleton,
  'post.draft.empty': EmptyDraft,
  
  // Tuple variant (TypeScript safety 100%)
  ['user', 'admin', 'success']: AdminPanel,
  ['post', 'published', 'error']: PostError,
}`,
    },
    {
      type: ContentType.Heading,
      content: 'Реальный кейс: NotificationCenter',
    },
    {
      type: ContentType.Code,
      content: `// ДО: 80 строк switch
  const Notification = ({ type, status }: { type: string, status: string }) => {
    switch (\`${'type'}.${'status'}\`) { // Уже хак, записали!
      case 'achievement.unlocked': 
        return <AchievementPop />;
        
      case 'comment.moderated': 
        return <ModerationNotice />;
        
      // ... 78 cases
    }
  };
  
  // ПОСЛЕ: 5 строк
  const Notification = ({ scope, entity, status }: {
    scope: Scope;
    entity: string;
    status: EntityState;
  }) => {
    const key = [scope, entity, status];
    
    const Component = COMPONENTS[key];
    
    return Component ? <Component /> : <DefaultNotification />;
  };`,
    },
    {
      type: ContentType.List,
      listTitle: 'Почему композитные ключи лучше switch:',
      listItems: [
        'TypeScript autocomplete: пишешь `user.admin` — IDE сразу подхватывает. Очень удобная штука, изначально использовал разделитель как "|", но потом заметил что IDE подхватывает',
        'Merge conflicts: добавляешь case? Один объект, а не 300 строк',
        'Bundle size: switch 80kb → объект 8kb',
        'Perf: Record lookup O(1) vs switch O(n)',
        'Dynamic keys: `user.${role}.${status}` без рефакторинга',
      ],
    },
    {
      type: ContentType.Paragraph,
      content: `В NotificationCenter switch ререндерил 42 раза за сессию, а compound keys - 3 раза. Profiler в шоке`,
    },
    {
      type: ContentType.Heading,
      content: 'Также нашел продвинутый вариант',
    },
    {
      type: ContentType.Heading,
      content: 'Factory + discriminated unions',
    },
    {
      type: ContentType.Code,
      content: `// Factory pattern + TS magic
type NotificationVariant = 
  | { scope: 'user'; role: 'admin' | 'user'; status: 'success' }
  | { scope: 'post'; entity: string; status: 'draft' | 'published' };

const notificationFactory = (variant: NotificationVariant): React.ComponentType => {
  const key = \`${'variant.scope'}.${'role in variant ? variant.role : variant.entity'}.${'variant.status'}\` as CompoundKey;
  
  return COMPONENTS[key] ?? DefaultNotification;
};

// Usage
const notify = notificationFactory({ scope: 'user', role: 'admin', status: 'success' });`,
    },
    {
      type: ContentType.Heading,
      content: 'Метрики до/после',
    },
    {
      type: ContentType.Code,
      content: `| Метрика             | Switch-case | Compound Keys | Выигрыш |
| ------------------- | ----------- | ------------- | ------- |
| Код строк           | 327         | 28            | ~12x    |
| Bundle size         | 82 KB       | 7.8 KB        | ~10x    |
| Re-renders/сек      | 41          | 3             | ~14x    |`,
    },
    {
      type: ContentType.Paragraph,
      content:
        'CLOSURE. Тестировал на большом кол-ве нотификейшнах и смотрел в React DevTools, свитч ререндерил соседние компоненты',
    },
    {
      type: ContentType.Heading,
      content: 'Итог, когда не использовать?',
    },
    {
      type: ContentType.List,
      listItems: [
        'Если меньше 5 вариантов, то switch проще',
        'Частые runtime ключи получаются лучше if/else',
      ],
    },
    {
      type: ContentType.Ad,
      content: 'Хочешь больше React+TS триков?',
      description: 'Реальные кейсы, perf хаки и TS. Все анонсы в тг',
      linkUrl: 'https://t.me/wazzupjohnny_channel',
      imageUrl:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/1280px-Telegram_logo.svg.png?20220101141644',
    },
  ],
  externalLinks: [
    {
      label: 'TypeScript Template Literal Types',
      url: 'https://www.typescriptlang.org/docs/handbook/2/template-literal-types.html',
    },
    {
      label: 'TanStack Query keys (аналог)',
      url: 'https://tanstack.com/query/latest/docs/framework/react/guides/query-keys',
    },
  ],
};
